














































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {DeleteBedScheduling, GetBedSchedulingList} from "@/api/bedScheduling"
import {GetPatients, GetShiftList, GetWardList} from "@/api/specialDictionary"
import Schedule from './parts/schedule'
import changebed from './parts/changebed.vue'

@Component({
	components: {Schedule,changebed}
})
export default class Country extends AbpBase {
	//换床
	changebedShow = false
	changebedData:any = {}
	patientsLoading = false
	// 班次
	shiftName: any = ''
	shiftNames = []
	shiftNamesTemp = [] // 用来生成表格
	// 病区
	wardName = ''
	wardNames = []
	// 单双泵
	droppedItem = ''
	machineType = ''
	// 患者集合
	patients = [
		{id: 1, name: "张三"},
		{id: 2, name: "李四"},
		{id: 3, name: "王二"},
		{id: 4, name: "赵武"},
	]

	get currentWeek() {
		return this.week[0] + ' 至 ' + this.week[this.week.length - 1]
	}
	//表格高度
	get tableHeight(){
		return window.innerHeight-200
	}

	weekPosition = 1
	//选中的患者
	selectPatinet: any = ''
	week = []
	data = []
	columns = []
	scheduleShow = false
	scheduleData = {}
	tableLoading = false
	flags = ['', '&#xe64f;', '&#xe620;', '&#xe640;', '&#xe600;']

	created() {
		this.week = this.getDates(this.weekPosition)
		this.getData()
		this.getSelects()
	}
	tableScrollX() {
		//scroll-x
		setTimeout(() => {
			let now = new Date();
			let day = now.getDay();
			let tableX:any = document.querySelector('.ivu-table-overflowX');
			console.log(tableX)
			tableX.scrollLeft = (day-1)*450
		}, 200);
	}
	shiftNameChange(val: any) {
		if (val == "") {
			this.shiftNamesTemp = this.shiftNames
		} else {
			this.shiftNamesTemp = [val]
		}
		this.tableChange()
	}

	tableChange() {
		this.getData()
		this.initTable()
	}

	scheduleShowChange() {
		this.scheduleShow = false
		this.getData()
	}

	exportCsv() {
		(this.$refs.table as any).exportCsv({
			filename: 'The original data'
		});
	}

	lestWeek() {
		this.weekPosition--
		this.week = this.getDates(this.weekPosition)
		this.initTable()
		this.getData()
	}

	nextWeek() {
		this.weekPosition++
		this.week = this.getDates(this.weekPosition)
		this.initTable()
		this.getData()
	}

	/**
	 *  生成表格结构
	 * */
	initTable() {
		this.selectedPatinetId = 0
		this.selectBedId = 0
		this.tableLoading = true
		this.columns = []
		this.columns.push({
			title: "床位",
			key: 'bedcode',
			align: 'center',
			width: 120,
			fixed: 'left',
			render: (h: any, params: any) => {
				return h('div', [
					h("div", params.row.wardName + '/' + params.row.bedcode),
					h("div", params.row.machineName),
				])
			}
		})
		let w = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
		let colors = ["#FFFFFF", "#FF6600", "#FF02FF", "#FF0001", "#3365FF", "#33CCCC"]
		let week = this.week  //本周一周的日期集合
		// let columns = []
		week.forEach((i: any, index: any) => {
			let column: any = {
				title: i + "  " + w[index],
				align: 'center',
				children: []
			}
			this.shiftNamesTemp.forEach((j: any) => {
				column.children.push({
					title: j.shiftName,
					align: 'center',
					width: 150,
					key: 'patientName',
					render: (h: any, params: any) => {
						// 绑定规则 row[周一到周日位置下标 加 班次id]
						let row_column = params.row['' + index + j.id]
						let checkd = this.changgBedList.find((ivm:any)=>{return ivm.x==params.add && ivm.y==params.column._index})
						if (row_column) {
							// 已排床
							return h('div', {
								style: {
									background: colors[row_column.colorEnum],
									color: row_column.colorEnum && row_column.colorEnum !== 3 ? 'white' : 'black',
									width: '100%',
									height: '60px',
									//  选中的患者 边框高亮
									border: this.selectedPatinetId === row_column.patientId ? "2px solid #00FF00" : "",
									overflow: 'hidden'
								},
							}, [
								h("Dropdown", {
									style: {
										width: "129px",
										height: '60px'
									},
									props: {
										trigger: 'click',
										transfer:true
									},
								}, [
									h('div', {}, [
										h('Row', {
											style: {
												height: '25px',
												marginTop: '5px'
											}
										}, [
											h("Col", {
												props: {
													span: 11,
												}
											}, [
												h('h4', row_column.patientName),
											]),
											h("Col", {
												props: {
													span: 12,
												}
											}, [
												h('h4', row_column.dialysisModelName),
											]),
											h("Col", {
												props: {
													span: 1,
												}
											}, [
												checkd?
												h("checkbox", {
													props:{
														value:true,
													},
													style:{
														// marginRight:"3px",
														// display: this.selectBedId === row_column.id ? "inline" : ""
														position: 'absolute',
														top: '-9px',
														right: '-16px',
													}

												}) : h("span"),
												//checkbox 不可点击（挡住）
												h('div',{
													style:{
														width:'20px',
														height:'20px',
														position: 'absolute',
														top: '-9px',
														right: '-16px',
														zIndex:9999
													}
												})
											]),

										]),
										h('Row', {
											style: {
												height: '30px'
											}
										}, [
											h("Col", {
												props: {
													span: 6,
												}
											}, [
												h('i', {
													class: 'iconfont',
													domProps: {
														innerHTML: this.flags[row_column.flagEnum]
													}
												}, this.flags[row_column.flagEnum]),
											]),
											h("Col", {
												props: {
													span: 18,
												}
											}, [
												h('span', row_column.remark),
											]),
										]),

									]),  //周一到周日位置下标 加 班次id
									h("DropdownMenu", {
										slot: "list",
										style: {
											// width: "100%",
										}
									}, [
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													if(checkd){
														let dindex = 0;
														this.changgBedList.forEach((ivm:any,ivi:any)=>{
															if(ivm.x==params.add && ivm.y==params.column._index){
																dindex = ivi
															}
														})
														this.changgBedList.splice(dindex,1)
													}else{
														this.changgBedList.push({
															x:`${params.add}`,
															y:`${params.column._index}`,
															row: Object.assign({},row_column),
															bed: params.row,
															shift: j,
															time: i + "/" + w[index],
															patients: this.patients
														})
													}
												}
											}
										},  checkd?"取消选择":'选择'),
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													this.scheduleData = {
														schedule: row_column,
														bed: params.row,
														shift: j,
														time: i + "/" + w[index],
														patients: this.patients
													}
													this.scheduleShow = true
												}
											}
										}, "设置"),
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													if(row_column.id != this.selectBedId){
														this.funSelectPatinet(row_column)
													}else{
														this.cancelSelectPatinet()
													}
												}
											}
										}, row_column.id != this.selectBedId ?"高亮":'取消高亮'),
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													this.copyBed(row_column)
												}
											}
										}, "复制"),
										
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													this.deleteSchedule(row_column.id)
												}
											}
										}, "清空"),
									])
								]),

							])
						} else {
							// 未排床
							return h('div', {
								style: {
									height: "60px",
									position:'relative'
								},
								on: {
									click: () => {
									},
									dragover: (event: any) => {
										event.preventDefault()
									},
									drop: (event: any) => {
										// 拖动事件接收参数
										let msg = JSON.parse(event.dataTransfer.getData('item'))
										this.scheduleData = {
											schedule: {
												patientId: msg.id
											},
											bed: params.row,
											shift: j,
											time: i + "/" + w[index],
											patients: this.patients
										}
										this.selectPatinet = {}
										this.scheduleShow = true
									}
								}
							}, [
								checkd ?
								h("checkbox", {
									props:{
										value:true,
									},
									style:{
										// marginRight:"3px",
										// display: this.selectBedId === row_column.id ? "inline" : ""
										position: 'absolute',
										top: '-4px',
										right: '-8px',
									}

								}) : h("span"),
								//checkbox 不可点击（挡住）
								h('div',{
									style:{
										width:'20px',
										height:'20px',
										position: 'absolute',
										top: '-4px',
										right: '-8px',
										zIndex:9999
									}
								}),
								h("Dropdown", {
									// trigger:"click",
									style: {
										width: "129px",
										// height: "48px"
									},
									props: {
										trigger: 'click',
										transfer:true
									},
								}, [
									h("div", {
										style: {
											width: "100%",
											lineHeight: "48px",
											height: "48px"
										}
									}, " "),
									h("DropdownMenu", {
										slot: "list",
									}, [
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													if(checkd){
														let dindex = 0;
														this.changgBedList.forEach((ivm:any,ivi:any)=>{
															if(ivm.x==params.add && ivm.y==params.column._index){
																dindex = ivi
															}
														})
														this.changgBedList.splice(dindex,1)
													}else{
														this.changgBedList.push({
															x:`${params.add}`,
															y:`${params.column._index}`,
															row:null,
															bed: params.row,
															shift: j,
															time: i + "/" + w[index],
															patients: this.patients
														})
													}
												}
											}
										},  checkd?"取消选择":'选择'),
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													this.scheduleData = {
														schedule: {
															id: ''
														},
														bed: params.row,
														shift: j,
														time: i + "/" + w[index],
														patients: this.patients
													}
													this.scheduleShow = true
												}
											}
										}, "添加患者排床"),
										!!this.copyedPatientId ?
										h("DropdownItem", {
											nativeOn: {
												click: () => {
													this.scheduleData = {
														schedule: {
															id: '',
															patientId: this.copyedPatientId
														},
														bed: params.row,
														shift: j,
														time: i + "/" + w[index],
														patients: this.patients,


													}
													this.scheduleShow = true
												}
											}
										}, "粘贴") : h("span")

									])
								])
							])
						}


					}
				})
			})
			this.columns.push(column)
		})
		this.tableLoading = false
		this.tableScrollX()
	}

	async deleteSchedule(id: any) {
		this.$confirm('将删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteBedScheduling({Id: id})
			this.getData()
		}).catch(() => {

		});
	}

	// 被拖动区域接收 数据并赋值
	drop1(event: any) {
		let data = JSON.parse(event.dataTransfer.getData('item'))
		this.droppedItem = data.patientName
	}

	// 拖动开始，在 拖动 event.dataTransfer 中放入数据
	dragstart(event: any, item: any) {
		event.dataTransfer.setData('item', JSON.stringify(item))
	}

	// 拖动事件结束后，清理数据
	dragend(event: any) {
		event.dataTransfer.clearData()
	}

	async getPatient(query: any) {
		this.patientsLoading = true
		let res = await GetPatients({
			QueryString: query,
			SkipCount: 1,
			MaxResultCount: 1000
		})
		this.patients = res.items
		this.patientsLoading = false
	}

	//  选中患者的id 用来让边框高亮
	selectedPatinetId = 0
	// 选中的位置
	selectBedId = 0
	//  选中某个患者 让本周该患者边框高亮
	funSelectPatinet(row: any) {
		this.selectedPatinetId = row.patientId
		this.selectBedId = row.id
	}
	cancelSelectPatinet(){
		this.selectedPatinetId = 0
		this.selectBedId = 0
	}
	//选择（换床）
	changgBedList:any = []
	darpBed(){
		console.log(this.changgBedList)
		this.changebedData = {
			list1:[],
			list2:[],
			weekPosition:this.weekPosition,
		}
		this.changgBedList.forEach((item:any,index:any)=>{
			//是否排床
			let bedItem = item.row
			item.$drops = false
			let tm = Object.assign({},item)
			if(bedItem){
				item.$drops = true
				this.changebedData.list1.push(item)
			}
			tm.row = null
			this.changebedData.list2.push(tm)
		})
		
		this.changebedShow = true
	}

	// 复制的患者id
	copyedPatientId = 0
	// 复制功能 获得选中的患者id
	copyBed(row:any){
		this.copyedPatientId = row.patientId
	}

	async getData() {
		this.tableLoading = true
		let res = await GetBedSchedulingList({
			ShiftName: this.shiftName.shiftName,
			MachineType: this.machineType,
			WardName: this.wardName,
			DialysisDateStart: this.week[0],
			DialysisDateEnd: this.week[6]
		})
		this.data = res.bedInfoDtoList  //床位集合，有多少个床位就有多少个行
		let success_num = 0
		let failure_num = 0
		if (res.bedSchedulingModelDtoList.length !== 0) {
			//  dataItem:包含床位信息     dataIndex:床位在table中的行数
			this.data.forEach((dataItem: any, dataIndex: any) => {
				dataItem.$check = false
				//  bedItem:排床信息      bedIndex:好像并不需要，先放着
				res.bedSchedulingModelDtoList.forEach((bedItem: any, bedIndex: any) => {
					if (bedItem.badId === dataItem.id) {
						let dialysisDate = new Date(bedItem.dialysisDate).toLocaleDateString() //透析日期
						let weekIndex = this.week.indexOf(dialysisDate.split('/').join('-')) //透析日期在本周的位置
						if (weekIndex !== -1) {
							dataItem["" + weekIndex + bedItem.shiftId] = bedItem
							success_num += 1
						} else {
							// failure_num += 1
						}
					} else {
						// failure_num += 1
					}
				})
			})
		}
		console.log(this.data)
		this.tableLoading = false
	}

	async getSelects() {
		let query = {
			SkipCount: 1,
			MaxResultCount: 10000
		}
		let res = await GetShiftList(query)
		this.shiftNames = res.items
		this.shiftNamesTemp = res.items
		let res1 = await GetWardList(query)
		this.wardNames = res1.items
		let res2 = await GetPatients({
			QueryString: '',
			SkipCount: 1,
			MaxResultCount: 1000
		})
		this.patients = res2.items
		this.initTable()
	}

	/**
	 * @return 周一到周日的日期集合
	 * @val 1 : 本周日期   2 : 下周
	 * toLocaleDateString()  获取date的日期  "2019/3/13"
	 * */
	getDates(val: any) {
		let week = (val - 1) * 7
		var new_Date = new Date()
		var timesStamp = new_Date.getTime();
		var currenDay = new_Date.getDay();
		var dates = [];
		for (var i = week; i < 7 * val; i++) {
			dates.push(new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)).toLocaleDateString().replace(/[年月]/g, '-').replace(/[日上下午]/g, ''));
		}
		return dates.map((item: any) => {
			if (item.indexOf('/') !== -1) {
				return item.split('/').join('-')
			} else {
				return item
			}

		})
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/bedScheduling/bed/index.vue